<template>
    <ToDo></ToDo>
</template>

<script>
    import ToDo from './_components/todo_bricks'

    export default {
        name: "Invoicing",

        data: () => ({}),

        created() {

        },

        mounted() {

        },

        components: {
            ToDo
        },

    };
</script>

<style scoped>

</style>
